const CATEGORIES_PREFIX = '@@categories/';

export const CATEGORIES_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${CATEGORIES_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${CATEGORIES_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${CATEGORIES_PREFIX}FETCH_LIST_FAILURE`,

    FETCH_SUBCATEGORIES_REQUEST: `${CATEGORIES_PREFIX}FETCH_SUBCATEGORIES_REQUEST`,
    FETCH_SUBCATEGORIES_SUCCESS: `${CATEGORIES_PREFIX}FETCH_SUBCATEGORIES_SUCCESS`,
    FETCH_SUBCATEGORIES_FAILURE: `${CATEGORIES_PREFIX}FETCH_SUBCATEGORIES_FAILURE`,
}

export const CATEGORIES_CONFIG = {
    CACHE_TIME: 60 * 1000,
}